import { useCallback } from 'react';

export const useSmoothNavigation = () => {
  const scrollToSection = useCallback((sectionId) => {
    console.log(`🎯 scrollToSection called for: ${sectionId}`);
    const element = document.getElementById(sectionId);
    
    if (element) {
      console.log(`✅ Element ${sectionId} found!`);
      const offset = 80; // Height of fixed navbar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      console.log(`📍 Scrolling to position: ${offsetPosition}px`);
      
      // Try smooth scroll first
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      // Fallback: Force scroll after a short delay if smooth scroll doesn't work
      setTimeout(() => {
        const currentScroll = window.pageYOffset;
        console.log(`📍 Current scroll position after smooth: ${currentScroll}px`);
        
        // If we haven't moved, force the scroll
        if (Math.abs(currentScroll - offsetPosition) > 50) {
          console.log(`⚠️ Smooth scroll didn't work, forcing scroll with scrollIntoView`);
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
        } else {
          console.log(`✅ Scroll successful!`);
        }
      }, 500);
    } else {
      console.error(`❌ Element with ID '${sectionId}' not found in DOM`);
      console.log('Available IDs:', Array.from(document.querySelectorAll('[id]')).map(el => el.id));
    }
  }, []);

  return { scrollToSection };
};
